import { useEffect, useState } from 'react';

/**
 * Breakpoint `lg` Tailwind, dibaca dari JavaScript.
 *
 * Dipakai saat satu komponen harus **benar-benar tidak dipasang** di salah satu
 * ukuran layar, bukan sekadar disembunyikan `lg:hidden`. Bedanya penting untuk
 * komponen yang bekerja sendiri: Wall Status memasang interval poll 60 detik
 * saat dipasang, jadi dua salinan yang saling disembunyikan CSS berarti dua
 * permintaan ke server tiap menit untuk satu bilah yang terlihat.
 *
 * Angkanya harus sama persis dengan `lg:` di kelas Tailwind pasangannya —
 * kalau tidak, ada satu lebar layar tempat keduanya hilang bersamaan.
 */
const LG = '(min-width: 1024px)';

export function useLayarLebar(): boolean {
  const [lebar, setLebar] = useState(() => window.matchMedia(LG).matches);

  useEffect(() => {
    const mq = window.matchMedia(LG);
    const onUbah = (e: MediaQueryListEvent) => setLebar(e.matches);
    mq.addEventListener('change', onUbah);
    // Dibaca ulang sekali: antara render pertama dan efek ini jendela bisa
    // sudah berubah (rotasi layar saat halaman dimuat).
    setLebar(mq.matches);
    return () => mq.removeEventListener('change', onUbah);
  }, []);

  return lebar;
}
